import { useState, useEffect } from "react";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import { ResetPasswordForm } from "./ResetPasswordForm";
import { PhoneVerificationForm } from "./PhoneVerificationForm";
import { useTranslation } from 'react-i18next';

type ForgotPasswordPopupProps = {
  show: boolean;
  onHide: () => void;
};

export function ForgotPasswordPopup({ show, onHide }: ForgotPasswordPopupProps) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<"email" | "phone">("email");
  const [showResetForm, setShowResetForm] = useState(false);
  const [showVerificationForm, setShowVerificationForm] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
   const [phoneCode,setPhoneCode] = useState("")

  // Reset state when modal is closed
  useEffect(() => {
    if (!show) {
      setShowResetForm(false);
      setShowVerificationForm(false);
      setEmail("");
      setPhone("");
      setActiveTab("email");
    }
  }, [show]);

  const handleFormStateChange = (showReset: boolean, userEmail?: string, userPhone?: string) => {
    if (showReset) {
      setShowResetForm(true);
      if (userEmail) {
        setEmail(userEmail);
      }
    } else if (userPhone) {
      setShowVerificationForm(true);
      setPhone(userPhone);
    }
  };

  const handleVerificationSuccess = (phone:string) => {
       setPhoneCode(phone)
    setShowVerificationForm(false);
    setShowResetForm(true);
  };

  const handleClose = () => {
    setShowResetForm(false);
    setShowVerificationForm(false);
    setEmail("");
    setPhone("");
    setActiveTab("email");
    onHide();
  };

  return (
    <div className="modal fade" id="forgotPasswordModal">
      <div className="modal-dialog modal-lg modal-dialog-centered login-modal modal-dialog-scrollable">
        <div
          className="modal-content"
          style={{
            backgroundColor: "transparent",
            border: 0,
            borderRadius: 0,
          }}
        >
          <button
            type="button"
            className="closed-modal"
            data-bs-dismiss="modal"
            onClick={handleClose}
          ></button>

          <div className="modal-body">
            <div id="login-modal">
              <div className="login-form default-form">
                <div className="form-inner">
                  <div style={{ 
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '20px',
                    marginTop: '20px'
                  }}>
                    <img
                      src="/images/phone_symbol.svg" 
                      alt="Phone Symbol" 
                      style={{ 
                        width: '60px', 
                        height: '60px',
                        display: 'block'
                      }} 
                    />
                  </div>
                  <h3 style={{ color: "white", fontWeight: 600 }}>
                    {showResetForm ? t('forgotPassword') : 
                     showVerificationForm ? "" : 
                     t('forgottenPassword')}
                  </h3>

                  {!showResetForm && !showVerificationForm ? (
                    <div className="tabs-box">
                      <div style={{ 
                        display: 'flex',
                        marginBottom: '30px'
                      }}>
                        <button
                          className={`theme-btn btn-style-one w-100 ${activeTab === "email" ? "active" : ""}`}
                          onClick={() => setActiveTab("email")}
                          style={{ 
                            backgroundColor: activeTab === "email" ? "#2D74EA" : "#5997FF",
                            border: activeTab === "email" ? "1px solid #fff" : "transparent",
                            color: activeTab === "email" ? "white" : "white",
                            height: '45px',
                            fontSize: '16px',
                            transition: 'all 0.3s ease',
                            borderRadius: 0
                          }}
                        >
                         {t('email')}
                        </button>
                        <button
                          className={`theme-btn btn-style-one w-100 ${activeTab === "phone" ? "active" : ""}`}
                          onClick={() => setActiveTab("phone")}
                          style={{ 
                            backgroundColor: activeTab === "phone" ? "#2D74EA" : "#5997FF",
                            border: activeTab === "phone" ? "1px solid #fff" : "transparent",
                            color: activeTab === "phone" ? "white" : "white",
                            height: '45px',
                            fontSize: '16px',
                            transition: 'all 0.3s ease',
                            borderRadius: 0
                          }}
                        >
                          {t('byPhone')}
                        </button>
                      </div>
                      <div className="tabs-content">
                        <div className="tab active-tab">
                          <ForgotPasswordForm 
                            type={activeTab} 
                            onHide={handleClose} 
                            onStateChange={handleFormStateChange}
                          />
                        </div>
                      </div>
                    </div>
                  ) : showResetForm ? (
                    <ResetPasswordForm email={email} onHide={handleClose} token={phoneCode}/>
                  ) : (
                    <PhoneVerificationForm phone={phone} onHide={handleClose} onVerificationSuccess={handleVerificationSuccess} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 